module.exports = __webpack_public_path__ + "static/your-stylist-result-1-539abe256c3afce38faa3ead4e7bd4f5.png";